var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dash-footer"},[_c('div',{staticClass:"container text-center"},[_c('p',[_vm._v("© "+_vm._s(_vm.footerYear)+" Safari-Tz")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }